import { configureStore } from '@reduxjs/toolkit';
import podsReducer from './slices/podsSlice';
import epicsReducer from './slices/epicsSlice';
import storiesReducer from './slices/storiesSlice';
import categoriesReducer from './slices/categoriesSlice';
import sprintsReducer from './slices/sprintsSlice';
import themeReducer, { THEME_MODE_KEY, THEME_ID_KEY } from './slices/themeSlice';
import healthConfigReducer from './slices/healthConfigSlice';
import stateManagementReducer from './slices/stateManagementSlice';
import backgroundReducer from './slices/backgroundSlice';
import developerModeReducer from './slices/developerModeSlice';
import workstreamsReducer from './slices/workstreamsSlice';

export const store = configureStore({
  reducer: {
    pods: podsReducer,
    epics: epicsReducer,
    stories: storiesReducer,
    categories: categoriesReducer,
    sprints: sprintsReducer,
    theme: themeReducer,
    healthConfig: healthConfigReducer,
    stateManagement: stateManagementReducer,
    background: backgroundReducer,
    developerMode: developerModeReducer,
    workstreams: workstreamsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

store.subscribe(() => {
  try {
    const { developerMode, theme } = store.getState();
    localStorage.setItem('developerMode', String(developerMode.developerMode));
    localStorage.setItem(THEME_MODE_KEY, theme.mode);
    localStorage.setItem(THEME_ID_KEY, theme.selectedThemeId);
  } catch {
    // ignore storage errors
  }
});
